import styled, { MQ_TABLET } from '../../../src/constants/theme'

export default styled.div(
  {
    fontSize: 13,
    maxWidth: '100%',
    textAlign: 'center',
    width: 500,
  },
  ({ theme }) => ({
    ...MQ_TABLET({
      '& + &': {
        paddingTop: 0,
      },
      padding: theme.padding,
    }),
    '& + &': {
      paddingTop: 0,
    },
    '& a': {
      '&:hover': {
        textDecoration: 'none',
      },
      fontWeight: 'bold',
      textDecoration: 'underline',
    },
    '&.footer': {
      fontWeight: 'bold',
    },
    color: theme.textLight,
    padding: theme.paddingMobile,
  }),
)
